import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

// Elements
import BackToTop from './elements/back-top';
import PageScrollTop from './elements/page-scroll-top';

// All Pages
import Index from './pages/index';
import AboutUs from './pages/about';
import BlogDetails from './pages/blog-details';
import BlogListSidebar from './pages/blog-list-sidebar';
import Booking from './pages/booking';
import ContactUs from './pages/contact';
import Faq1 from './pages/faq-1';
import Services from './pages/service-1';
import ThankYou from './pages/thank-you';
import ThankYouEmail from './pages/thank-you-email';
import Error from './pages/error-404';
import TermsAndConditions from './pages/terms-and-conditions';
import PrivacyPolicy from './pages/privacy-policy';
import CancellationPolicy from './pages/cancellation-policy';
import RefundPolicy from './pages/refund-policy';
import DeleteAccount from './pages/delete-account';
import Complaint from './pages/complaint';
import MechanicLogin from './pages/mechanic-login';
import MechanicKYC from './pages/mechanic-kyc';
import MechanicDashboard from './pages/mechanic-dashboard';
import MechanicBookingDetails from './pages/mechanic-booking-details';
import PartnerLogin from './pages/partner-login';
import PartnerDashboard from './pages/partner-dashboard';
import BookingDetails from './pages/booking-details';
import KeywordLanding from "./pages/keyword-landing";
import Login from './pages/login';
import Register from './pages/register';
import BookingHistory from './pages/booking-history';
import PassportSurface from './pages/passport';
import HowWeWork from './pages/how-we-work';
import FranchisePage from './pages/franchise';
import Careers from './pages/careers';
import CareerDetails from './pages/career-details';
import CarAcRepairPage from './pages/car-ac-repair';
import ZomatoRiderServices from './elements/zomato-rider-services';
import CategoryHub, { HUBS } from './pages/category-hub';
import BrandsIndex from './pages/brands-index';
import BrandPage from './pages/brand-page';
import ModelPage from './pages/model-page';
import ProgrammaticServicePage from './pages/programmatic-service-page';
import ProgrammaticHubPage from './pages/programmatic-hub-page';
import QrVerifyPage from './pages/qr-verify';
import AppDownloadPage from './pages/app-download';
import GoMechanicComparison from './pages/gomechanic-comparison';
import MechanicNearMe from './pages/mechanic-near-me';
import UrbanCompanyComparison from './pages/urbancompany-comparison';
import cityContent from '../data/city_content.json';
import keywordPages from "../data/keyword_pages.json";

class Markup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blogsData: [],
      blogsLoaded: false
    };
  }

  componentDidMount() {
    // Load blogs index asynchronously
    fetch('/blogs-index.json')
      .then(res => res.json())
      .then(data => {
        this.setState({
          blogsData: data,
          blogsLoaded: true
        });
      })
      .catch(error => {
        console.error('Error loading blogs index:', error);
        this.setState({
          blogsData: [],
          blogsLoaded: true
        });
      });
  }

  render() {
    // Extract common props to pass to all route components
    const commonProps = {
      isMobileBrowser: this.props.isMobileBrowser,
      isMobileApp: this.props.isMobileApp,
      citiesModal: this.props.citiesModal,
      setCitiesModal: this.props.setCitiesModal,
      openModal: this.props.openModal,
      setOpenModal: this.props.setOpenModal,
      user: this.props.user,
      setUser: this.props.setUser,
      userVehicles: this.props.userVehicles,
      setUserVehicles: this.props.setUserVehicles,
      setShowChatBot: this.props.setShowChatBot,
      blogsData: this.state.blogsData,
      cityContent: cityContent,
    };

    const keywordSlugs = Object.keys(keywordPages);

    return (
      <>
        <Switch>
          <Route
            path='/'
            exact
            render={(props) => <Index {...props} {...commonProps} />}
          />
          <Route
            path='/auto_ad'
            exact
            render={(props) => <Index {...props} {...commonProps} />}
          />
          <Route
            path='/sobha_ad'
            exact
            render={(props) => <Index {...props} {...commonProps} />}
          />
          <Route
            path='/iris_ad'
            exact
            render={(props) => <Index {...props} {...commonProps} />}
          />
          <Route
            path='/windsor_ad'
            exact
            render={(props) => <Index {...props} {...commonProps} />}
          />
          <Route
            path='/purva_ad'
            exact
            render={(props) => <Index {...props} {...commonProps} />}
          />
          <Route
            path='/marvella_ad'
            exact
            render={(props) => <Index {...props} {...commonProps} />}
          />
          <Route
            path='/city/:cityName'
            exact
            render={(routeProps) => (
              <Index
                {...routeProps}
                cityKey={routeProps.match.params.cityName}
                {...commonProps}
              />
            )}
          />
          <Route
            exact
            path='/city/:cityName/:areaName'
            render={(routeProps) => (
              <Index
                {...routeProps}
                cityKey={routeProps.match.params.cityName}
                areaKey={routeProps.match.params.areaName} 
                {...commonProps}
              />
            )}
          />

          {/* Dedicated rich pages — must come before keywordSlugs to take priority */}
          <Route
            path='/car-ac-repair-near-me'
            exact
            render={(props) => <CarAcRepairPage {...props} {...commonProps} />}
          />
          <Route
            path='/ac-repair'
            exact
            render={(props) => <CarAcRepairPage {...props} {...commonProps} />}
          />

          {/* Category hub pages */}
          {Object.keys(HUBS).map((hubSlug) => (
            <Route
              key={hubSlug}
              path={`/${hubSlug}`}
              exact
              render={(props) => (
                <CategoryHub {...props} hubSlug={hubSlug} {...commonProps} />
              )}
            />
          ))}

          {/* Brand pages */}
          <Route
            path='/brands'
            exact
            render={(props) => <BrandsIndex {...props} {...commonProps} />}
          />
          <Route
            path='/brands/:brandSlug/:modelSlug'
            exact
            render={(routeProps) => (
              <ModelPage
                brandSlug={routeProps.match.params.brandSlug}
                modelSlug={routeProps.match.params.modelSlug}
                {...routeProps}
                {...commonProps}
              />
            )}
          />
          <Route
            path='/brands/:brandSlug'
            exact
            render={(routeProps) => (
              <BrandPage
                brandSlug={routeProps.match.params.brandSlug}
                {...routeProps}
                {...commonProps}
              />
            )}
          />

          {/* Programmatic city x brand x service pages */}
          <Route path="/bike-service/:brand/:city" render={(routeProps) => <ProgrammaticServicePage {...routeProps} {...commonProps} />} />
          <Route path="/bike-repair/:brand/:city" render={(routeProps) => <ProgrammaticServicePage {...routeProps} {...commonProps} />} />
          <Route path="/bike-oil-change/:brand/:city" render={(routeProps) => <ProgrammaticServicePage {...routeProps} {...commonProps} />} />
          <Route path="/car-service/:brand/:city" render={(routeProps) => <ProgrammaticServicePage {...routeProps} {...commonProps} />} />
          <Route path="/car-repair/:brand/:city" render={(routeProps) => <ProgrammaticServicePage {...routeProps} {...commonProps} />} />
          <Route path="/car-ac-repair/:brand/:city" render={(routeProps) => <ProgrammaticServicePage {...routeProps} {...commonProps} />} />
          <Route path="/car-battery/:brand/:city" render={(routeProps) => <ProgrammaticServicePage {...routeProps} {...commonProps} />} />

          {/* Programmatic L2 hubs: /{service}/:brand → cities for that brand+service
              (also resolves the leaf breadcrumb's brand-level parent). */}
          {['bike-service', 'bike-repair', 'bike-oil-change', 'car-service', 'car-repair', 'car-ac-repair', 'car-battery'].map((s) => (
            <Route
              key={`hub-${s}`}
              exact
              path={`/${s}/:brand`}
              render={(routeProps) => <ProgrammaticHubPage service={s} {...routeProps} {...commonProps} />}
            />
          ))}

          {/* Programmatic L1 hubs for the two service slugs without a keyword page
              (the other 5 /{service} resolve via KeywordLanding). */}
          <Route exact path="/car-ac-repair" render={(routeProps) => <ProgrammaticHubPage service="car-ac-repair" {...routeProps} {...commonProps} />} />
          <Route exact path="/car-battery" render={(routeProps) => <ProgrammaticHubPage service="car-battery" {...routeProps} {...commonProps} />} />

          {/* Mechanic near me hub */}
          <Route
            path='/mechanic-near-me'
            exact
            render={(props) => <MechanicNearMe {...props} {...commonProps} />}
          />

          {/* Competitor comparison pages */}
          <Route
            path='/gomechanic-vs-ride-n-repair'
            exact
            render={(props) => <GoMechanicComparison {...props} {...commonProps} />}
          />
          <Route
            path='/urban-company-vs-ride-n-repair'
            exact
            render={(props) => <UrbanCompanyComparison {...props} {...commonProps} />}
          />

          {keywordSlugs.map((slug) => (
            <Route
              exact
              key={slug}
              path={`/${slug}`}
              render={(props) => (
                <KeywordLanding
                  {...props}
                  slug={slug}
                  {...commonProps}
                />
              )}
            />
          ))}

          <Route
            path='/about'
            exact
            render={(props) => <AboutUs {...props} {...commonProps} />}
          />
          <Route
            path='/blog-details/:slug'
            exact
            render={(props) => (
              <BlogDetails {...props} {...commonProps} />
            )}
          />
          <Route
            path='/blogs'
            exact
            render={(props) => (
              <BlogListSidebar {...props} {...commonProps} />
            )}
          />
          <Route
            path='/booking'
            exact
            render={(props) => <Services {...props} {...commonProps} />}
          />
          <Route
            path='/zomato_riders'
            exact
            render={(props) => <ZomatoRiderServices {...props} {...commonProps} />}
          />
          <Route
            path='/checkout'
            exact
            render={(props) => <Booking {...props} {...commonProps} />}
          />
          <Route
            path='/contact'
            exact
            render={(props) => <ContactUs {...props} {...commonProps} />}
          />
          <Route
            path='/franchise'
            exact
            render={(props) => <FranchisePage {...props} {...commonProps} />}
          />
          <Route
            path='/careers'
            exact
            render={(props) => <Careers {...props} {...commonProps} />}
          />
          <Route
            path='/careers/:jobSlug'
            exact
            render={(props) => <CareerDetails {...props} {...commonProps} />}
          />
          <Route
            path='/faq'
            exact
            render={(props) => <Faq1 {...props} {...commonProps} />}
          />
          <Route
            path='/service'
            exact
            render={(props) => <Services {...props} {...commonProps} />}
          />
          <Route
            path='/thank-you'
            exact
            render={(props) => <ThankYou {...props} {...commonProps} />}
          />
          <Route
            path='/thank-you-email'
            exact
            render={(props) => (
              <ThankYouEmail {...props} {...commonProps} />
            )}
          />
          <Route
            path='/terms-and-conditions'
            exact
            render={(props) => (
              <TermsAndConditions {...props} {...commonProps} />
            )}
          />
          <Route
            path='/privacy-policy'
            exact
            render={(props) => (
              <PrivacyPolicy {...props} {...commonProps} />
            )}
          />
          <Route
            path='/cancellation-policy'
            exact
            render={(props) => (
              <CancellationPolicy {...props} {...commonProps} />
            )}
          />
          <Route
            path='/refund-policy'
            exact
            render={(props) => (
              <RefundPolicy {...props} {...commonProps} />
            )}
          />
          <Route
            path='/delete-account'
            exact
            render={(props) => (
              <DeleteAccount {...props} {...commonProps} />
            )}
          />
          <Route
            path='/complaint'
            exact
            render={(props) => (
              <Complaint {...props} {...commonProps} />
            )}
          />
          <Route
            path='/mechanic-login'
            exact
            render={(props) => (
              <MechanicLogin {...props} {...commonProps} />
            )}
          />
          <Route
            path='/mechanic-kyc'
            exact
            render={(props) => (
              <MechanicKYC {...props} {...commonProps} />
            )}
          />
          <Route
            path='/mechanic-dashboard/:bookingId'
            exact
            render={(props) => (
              <MechanicBookingDetails {...props} {...commonProps} />
            )}
          />
          <Route
            path='/mechanic-dashboard'
            exact
            render={(props) => (
              <MechanicDashboard {...props} {...commonProps} />
            )}
          />
          <Route
            path='/partner-login'
            exact
            render={(props) => (
              <PartnerLogin {...props} {...commonProps} />
            )}
          />
          <Route
            path='/login'
            exact
            render={(props) => <Login {...props} {...commonProps} />}
          />
          <Route
            path='/register'
            exact
            render={(props) => <Register {...props} {...commonProps} />}
          />
          <Route
            path='/partner-dashboard'
            exact
            render={(props) => (
              <PartnerDashboard {...props} {...commonProps} />
            )}
          />
          <Route
            path='/booking-history'
            exact
            render={(props) => (
              <BookingHistory {...props} {...commonProps} />
            )}
          />
          <Route
            path='/passport'
            exact
            render={(props) => (
              <PassportSurface {...props} {...commonProps} />
            )}
          />
          <Route
            path='/booking-details'
            exact
            render={(props) => (
              <BookingDetails {...props} {...commonProps} />
            )}
          />
          <Route
            path='/how-ride-n-repair-works'
            exact
            render={(props) => (
              <HowWeWork {...props} {...commonProps} />
            )}
          />
          <Route
            path='/u/:code'
            exact
            render={(props) => <QrVerifyPage code={props.match.params.code} {...props} {...commonProps} />}
          />
          <Route
            path='/app'
            exact
            render={(props) => <AppDownloadPage {...props} {...commonProps} />}
          />
          <Route
            path='/error-404'
            exact
            render={(props) => <Error {...props} {...commonProps} />}
          />
          <Route component={Error} />
        </Switch>

        <PageScrollTop />
        {/* <BackToTop /> */}
      </>
    );
  }
}

export default Markup;
